export default __webpack_public_path__ + "static/media/819.9ff45d75.png";